import "./eventos.scss";

interface Evento {
  id: number;
  tipo: "curso" | "evento" | "novedad";
  titulo: string;
  descripcion: string;
  fecha: string;
  hora?: string;
  lugar?: string;
  badge?: string;
}

const eventos: Evento[] = [
  {
    id: 1,
    tipo: "novedad",
    titulo: "Actualización de Aranceles 2026",
    descripcion:
      "Se informa a todos los matriculados que a partir del 1° de junio de 2026 entran en vigencia los nuevos valores de cuota mensual y aranceles de trámites.",
    fecha: "2026-05-11",
  },
  {
    id: 2,
    tipo: "evento",
    titulo: "Asamblea Anual Ordinaria 2026",
    descripcion:
      "Un espacio de encuentro para compartir, informarse y ser parte de las decisiones que fortalecen nuestra profesión.",
    fecha: "2026-06-10",
    hora: "09:00 hs",
    lugar:
      "9 de Julio Nº 525. Escuela de Apoyo a la Inclusión Nº 1 Santa Rosa, La Pampa",
  },
  //   {
  //     id: 3,
  //     tipo: "curso",
  //     titulo: "Capacitación en Facturación por Obra Social",
  //     descripcion:
  //       "Formación obligatoria para matriculados que deseen ingresar al listado de prestadores. A cargo del equipo administrativo del Colegio.",
  //     fecha: "2026-05-28",
  //     hora: "18:00 hs",
  //     lugar: "Sede COFOLP – Av. Spinetto 670",
  //     badge: "Obligatorio",
  //   },

  //   {
  //     id: 6,
  //     tipo: "novedad",
  //     titulo: "Nueva modalidad de pago de cuota mensual",
  //     descripcion:
  //       "Se habilita el pago de la cuota mensual mediante transferencia bancaria y billeteras virtuales. Los comprobantes deben enviarse al email del Colegio.",
  //     fecha: "2026-07-01",
  //   },
  {
    id: 7,
    tipo: "curso",
    titulo: "Conversatorio en Disfagia",
    descripcion:
      "A cargo de la Lic. María Teresa Laurenti, Licenciada en Fonoaudiología, Diplomada en Abordaje Interdisciplinario de la Deglución y sus Dificultades en el Paciente Adulto. Jornada NO arancelada. Inscripción online.",
    fecha: "2026-06-06",
    hora: "10:00 – 13:00 hs",
    lugar: "A confirmar",
    badge: "Gratuito",
  },
];

const TIPO_CONFIG = {
  curso: { label: "Curso", icon: "bi-mortarboard-fill", color: "cyan" },
  evento: { label: "Evento", icon: "bi-calendar-event-fill", color: "green" },
  novedad: { label: "Novedad", icon: "bi-megaphone-fill", color: "amber" },
};

function formatFecha(iso: string) {
  const [y, m, d] = iso.split("-");
  const meses = [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sep",
    "oct",
    "nov",
    "dic",
  ];
  return { dia: d, mes: meses[parseInt(m) - 1], anio: y };
}

export default function Eventos() {
  return (
    <section id="eventos" className="section eventos-page">
      <div className="container section-title fade-up text-center mb-5">
        <h2>Cursos, Eventos y Novedades</h2>
        <p>
          Manténgase informado sobre las últimas actividades, capacitaciones y
          noticias del Colegio de Fonoaudiólogos de La Pampa.
        </p>
      </div>

      <div className="container fade-up">
        {/* Filtro visual por tipo */}
        <div className="tipo-badges mb-5">
          <span className="tipo-badge cyan">
            <i className="bi bi-mortarboard-fill"></i> Cursos
          </span>
          <span className="tipo-badge green">
            <i className="bi bi-calendar-event-fill"></i> Eventos
          </span>
          <span className="tipo-badge amber">
            <i className="bi bi-megaphone-fill"></i> Novedades
          </span>
        </div>

        <div className="row gy-4">
          {eventos.map((ev) => {
            const cfg = TIPO_CONFIG[ev.tipo];
            const fecha = formatFecha(ev.fecha);
            return (
              <div key={ev.id} className="col-lg-4 col-md-6">
                <div className={`evento-card evento-card--${cfg.color}`}>
                  {/* Fecha */}
                  <div className={`evento-fecha fecha--${cfg.color}`}>
                    <span className="dia">{fecha.dia}</span>
                    <span className="mes">{fecha.mes}</span>
                    <span className="anio">{fecha.anio}</span>
                  </div>

                  {/* Contenido */}
                  <div className="evento-body">
                    <div className="evento-header">
                      <span className={`evento-tipo tipo--${cfg.color}`}>
                        <i className={`bi ${cfg.icon}`}></i>
                        {cfg.label}
                      </span>
                      {ev.badge && (
                        <span className="evento-badge">{ev.badge}</span>
                      )}
                    </div>

                    <h4 className="evento-titulo">{ev.titulo}</h4>
                    <p className="evento-desc">{ev.descripcion}</p>

                    {(ev.hora || ev.lugar) && (
                      <div className="evento-meta">
                        {ev.hora && (
                          <span>
                            <i className="bi bi-clock"></i> {ev.hora}
                          </span>
                        )}
                        {ev.lugar && (
                          <span>
                            <i className="bi bi-geo-alt"></i> {ev.lugar}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="eventos-footer fade-up">
          <i className="bi bi-info-circle"></i>
          Para más información o inscripciones comunicarse al{" "}
          <strong>02954-702284</strong> o por email a{" "}
          <strong>cofolp@gmail.com</strong>
        </div>
      </div>
    </section>
  );
}
